import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Route, Switch } from 'react-router';
import * as registrationActions from '../../../actions/registration';
import { Link } from 'react-router-dom';
import Header from '../../Header';
import Bipolar from './Bipolar';
import BipolarTreatment from './BipolarTreatment';

class Engage1 extends React.Component {
  state = {
    errors: []
  }

  componentWillMount() {
    this.props._registration.updateProperty('access_code', 'Engage1');
  }

  onChange = e => {
    this.props._registration.updateProperty('access_code', e.target.value);
  }

  validateCode = e => {
    e.preventDefault();
    let errors = [];

    if (this.props.registration.get('access_code') === '') {
      errors.push('An access code is required');
    }

    if (this.state.errors.length < 1) {
      this.props._registration.validateCode(this.props.registration.get('access_code'), true)
        .then(res => res.text())
        .then(res => this.props._registration.validateCode(this.props.registration.get('access_code'), false))
        .then(res => res.json())
        .then(res => this.props._registration.updateProperty('site', res))
        .then(res => this.props.history.push('/register'))
        .catch(err => this.setState({ errors: ['Invalid Access Code'] }));
    }

    this.setState({ errors: errors });
  }

  render() {
    return (
     <section className="hero home is-fullheight">
      <Header {...this.props} />
      <div className="hero-body">
        <div className="container has-text-centered">

          <Switch>
            <Route path="/engage1/bipolar" component={Bipolar} />
            <Route path="/engage1/bipolartreatment" component={BipolarTreatment} />
          </Switch>    

          <form onSubmit={this.validateCode}>

            <div className="field is-grouped-desktop">
              <div className="control">
                <input className="input is-large" type="text" placeholder="Access Code" value={this.props.registration.get('access_code')} onChange={this.onChange} />
                {this.state.errors.length > 0 && this.state.errors.map((e, i) => <div className="help is-danger" style={{fontWeight: 700}}>{e}</div>)}
              </div>
              <div className="control">
                <button type="submit" className="button is-fullwidth is-large is-golden">Next</button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </section>
    );
  }
}

function mapStateToProps(state) {
  return {
    registration: state.registration
  };
}

function mapDispatchToProps(dispatch) {
  return {
    _registration: bindActionCreators(registrationActions, dispatch)
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Engage1);



// WEBPACK FOOTER //
// ./src/components/pages/landing/Engage1.js